export const GETWAREHOUSE_SUCCESS = "GETWAREHOUSE_SUCCESS";
export const GETWAREHOUSE_ERROR = "GETWAREHOUSE_ERROR";

export const ADDWAREHOUSE_SUCCESS = "ADDWAREHOUSE_SUCCESS";
export const ADDWAREHOUSE_ERROR = "ADDWAREHOUSE_ERROR";

export const UPDATEWAREHOUSE_SUCCESS = "UPDATEWAREHOUSE_SUCCESS";
export const UPDATEWAREHOUSE_ERROR = "UPDATEWAREHOUSE_ERROR";

export const DELETEWAREHOUSE_SUCCESS = "DELETEWAREHOUSE_SUCCESS";
export const DELETEWAREHOUSE_ERROR = "DELETEWAREHOUSE_ERROR"

export const GETWAREHOUSEPRODUCT_SUCCESS = "GETWAREHOUSEPRODUCT_SUCCESS";
export const GETWAREHOUSEPRODUCT_ERROR = "GETWAREHOUSEPRODUCT_ERROR";

export const GETCITY_SUCCESS = "GETCITY_SUCCESS";
export const GETCITY_ERROR = "GETCITY_ERROR";

export const EXPORT_WAREHOUSE_ITEM_SUCCESS = "EXPORT_WAREHOUSE_ITEM_SUCCESS";
export const EXPORT_WAREHOUSE_ITEM_ERROR = "EXPORT_WAREHOUSE_ITEM_ERROR";